/**
 * Live narration is a page-scoped spend. Leaving the mission, or the page,
 * must turn it off — the monitor would otherwise keep calling the model.
 *
 * Mounted on the workspace (and the packet page's open mission), not the
 * Live tab: switching dock tabs is not leaving.
 */
import { useEffect } from 'react';
import { stopSentinelLive } from '../../services/missionApi';

export function useStopSentinelLive(
  mission: { id: number; sentinel_live_enabled?: boolean } | null | undefined,
) {
  const id = mission?.id;
  const live = !!mission?.sentinel_live_enabled;

  useEffect(() => {
    if (!id || !live) return undefined;
    const stop = () => stopSentinelLive(id);
    window.addEventListener('pagehide', stop);
    return () => {
      window.removeEventListener('pagehide', stop);
      stop();
    };
  }, [id, live]);
}
